const CACHE_KEY = "auth-config";
const DEFAULT_CONFIG = { authProvider: "AzureAD", loginUrl: null };

/**
 * Synchronously read auth config from localStorage cache.
 * Returns default config if cache is empty or invalid.
 */
export function getCachedAuthConfig() {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      return JSON.parse(cached);
    }
    return DEFAULT_CONFIG;
  } catch {
    return DEFAULT_CONFIG;
  }
}

/**
 * Fetch auth config from the API and update localStorage cache.
 * Returns cached config on network error.
 */
export async function fetchAuthConfig() {
  try {
    const response = await fetch("/api/v1/auth-config");
    if (!response.ok) {
      throw new Error("Failed to fetch auth config");
    }
    const data = await response.json();

    // Normalize PascalCase response to camelCase
    const config = {
      authProvider: data.authProvider || "AzureAD",
      loginUrl: data.loginUrl || null,
      logoutUrl: data.logoutUrl || null,
    };

    localStorage.setItem(CACHE_KEY, JSON.stringify(config));
    return config;
  } catch (error) {
    console.error("Error fetching auth config:", error);
    return getCachedAuthConfig();
  }
}

/**
 * Check if the auth provider is AcesWeb.
 */
export function isAcesWebProvider(config) {
  return config?.authProvider === "AcesWeb";
}
